var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.005 0.0935059C19.107 0.0935059 20 0.991506 20 2.08351V18.1035C20 19.2025 19.107 20.0935 18.005 20.0935H2V16.0935H0V14.0935H2V11.0935H0V9.09351H2V6.09351H0V4.09351H2V0.0935059H18.005ZM6 2.09351H4V18.0935H6V2.09351ZM18 2.09351H8V18.0935H18V2.09351Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/Planning.18fa9570260eb8f60591331f2c93f1cf.svg";
export { ForwardRef as ReactComponent };